import React from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";

import { setBreadcrumb } from "../actions/common";
import {
  fetchDynamicInfo
} from "../actions/homePage";

const styles = {
  welcome1English: {
    fontSize: 26,
    fontWeight: 500,
    width: 464,
    textAlign: "center",
    marginBottom: 40,
    maxWidth: "85%"
  },
  welcome1French: {
    fontSize: 26,
    fontWeight: 500,
    width: 524,
    textAlign: "center",
    marginBottom: 40,
    maxWidth: "85%"
  },
  welcome1Englishv2: {
    fontSize: 18,
    fontWeight: 500,
    textAlign: "center",
    marginBottom: 40,
    maxWidth: "100%",
    lineHeight: "24px"
  },
  welcome1Frenchv2: {
    fontSize: 18,
    fontWeight: 500,
    textAlign: "center",
    marginBottom: 40,
    maxWidth: "100%",
    lineHeight: "24px"
  },
  welcome2English: {
    fontSize: 20,
    fontWeight: 400,
    width: 504,
    textAlign: "center",
    marginTop: 40,
    color: "#757575",
    maxWidth: "85%"
  },
  welcome2French: {
    fontSize: 20,
    fontWeight: 400,
    width: 504,
    textAlign: "center",
    marginTop: 40,
    color: "#757575",
    maxWidth: "85%",
  },
  welcome2Englishv2: {
    fontSize: 16,
    fontWeight: 400,
    textAlign: "center",
    marginTop: 40,
    color: "#757575",
    maxWidth: "100%",
    lineHeight: "22px"
  },
  welcome2Frenchv2: {
    fontSize: 16,
    fontWeight: 400,
    textAlign: "center",
    marginTop: 40,
    color: "#757575",
    maxWidth: "100%",
    lineHeight: "22px"
  }
};

const HomePage = (props) => {
  const {
    dispatch,
    classes,
    language,
    dynamicThemeInfo,
  } = props;

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([
        {
          name: I18n.get("topbar_home"),
        },
      ])
    );

    dispatch(fetchDynamicInfo());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  if (getWidth() < 470) {
    return (
      <Grid container className="height-100" direction="column">
        <Grid
          item
          xs
          className="mainContainer"
          style={{ padding: 0, paddingTop: 24 }}
        >
          <Box
            className="mainContent flexCenter"
            style={{
              justifyContent: "center",
              flexDirection: "column",
              padding: "24px",
              boxSizing: "border-box",
            }}
          >
            <span
              className={
                language === "en"
                  ? classes.welcome1Englishv2
                  : classes.welcome1Frenchv2
              }
            >
              {dynamicThemeInfo ? dynamicThemeInfo.customer.messages.welcome : null}

            </span>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img id="company_splash"
                src={"/dynamic/theme/logo/splash"}
                style={{ maxWidth: 500, maxHeight: 500, width: "50%" }}
                alt="company_splash"
              />
            </div>
            <span
              className={
                language === "en"
                  ? classes.welcome2Englishv2
                  : classes.welcome2Frenchv2
              }
            >
              {dynamicThemeInfo && dynamicThemeInfo["customer"] ? dynamicThemeInfo.customer.messages.mission : null}
            </span>
          </Box>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid container className="height-100" direction="column">
        <Grid item xs className="mainContainer">
          <Box
            className="mainContent flexCenter"
            style={{ justifyContent: "center", flexDirection: "column" }}
          >
            <span
              className={
                language === "en"
                  ? classes.welcome1English
                  : classes.welcome1French
              }
            >
              {dynamicThemeInfo && dynamicThemeInfo["customer"] ? dynamicThemeInfo.customer.messages.welcome : null}
            </span>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img id="company_splash"
                src={"/dynamic/theme/logo/splash"}
                style={{ maxWidth: 500, maxHeight: 500, width: "65%" }}
                alt="company_splash"
              />
            </div>
            <span
              className={
                language === "en"
                  ? classes.welcome2English
                  : classes.welcome2French
              }
            >
              {dynamicThemeInfo && dynamicThemeInfo["customer"] ? dynamicThemeInfo.customer.messages.mission : null}
            </span>
          </Box>
        </Grid>
      </Grid>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    zones: get(state, ["zones"]),
    dynamicThemeSplash: get(state, ["homePage", "dynamicThemeSplash"]),
    dynamicThemeInfo: get(state, ["homePage", "dynamicThemeInfo"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(HomePage))
);
